import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LockedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Locked",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.68 11.7h-1.07v-1.07c0-4.76-3.86-8.62-8.62-8.62s-8.62 3.85-8.62 8.61v1.07H6.32c-2.08 0-3.77 1.69-3.77 3.77v10.76c0 2.08 1.69 3.77 3.77 3.77h19.37c2.08 0 3.77-1.69 3.77-3.77V15.46c0-2.08-1.69-3.77-3.77-3.77Zm-6.46 7.56c0 1.19-.96 2.15-2.15 2.15v3.22a1.071 1.071 0 0 1-2.14 0v-3.24c-1.19 0-2.16-.96-2.16-2.16s.96-2.16 2.16-2.16h2.15c1.19.02 2.14.98 2.15 2.17Zm-8.61-8.63c0-2.97 2.41-5.39 5.39-5.39s5.39 2.41 5.39 5.39v1.07H10.62v-1.07Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "m17.51 25-1.22-4.57L15.06 25z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.51 26.14h-2.45c-.36 0-.69-.17-.91-.45s-.29-.65-.2-.99l1.23-4.57c.13-.5.59-.85 1.1-.85.52 0 .97.35 1.1.85l1.22 4.57c.09.34.02.71-.2.99s-.55.45-.91.45Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M24.29 31.86h-16c-1.89 0-3.43-1.54-3.43-3.43v-16C4.86 10.54 6.4 9 8.29 9h16c1.89 0 3.43 1.54 3.43 3.43v16c0 1.89-1.54 3.43-3.43 3.43m-16-20.57c-.63 0-1.14.51-1.14 1.14v16c0 .63.51 1.14 1.14 1.14h16c.63 0 1.14-.51 1.14-1.14v-16c0-.63-.51-1.14-1.14-1.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.86 11.29c-.63 0-1.14-.51-1.14-1.14V5.58c0-1.89-1.54-3.43-3.43-3.43s-3.43 1.54-3.43 3.43v4.57a1.14 1.14 0 1 1-2.28 0V5.58c-.01-3.16 2.56-5.72 5.71-5.72S22 2.42 22 5.57v4.57c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "16.29",
        cy: "17.57",
        r: "1.71"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.29 20.43a2.86 2.86 0 1 1-.001-5.719 2.86 2.86 0 0 1 .001 5.719m0-3.43c-.31 0-.57.26-.57.57s.26.57.57.57.57-.26.57-.57-.26-.57-.57-.57"
      })]
    })
  }));
};
LockedIcon.displayName = 'LockedIcon';